import { Flare } from "~/components/form/journal/Flare";
import { Authorize } from "~/components/permission/Authorize";

export default function AddFlare() {
    return (
        <Authorize ability="update" section={"symptoms"}>
            <Flare asRoute />
        </Authorize>
    );
}
